<template>
  <div class="">
    <van-nav-bar
      title="用户协议"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
        @click-right="onClickRight"
      :fixed="true"
    >
    <!-- <template #right>
      <img class="img" src="../../../assets/diq.png" alt="">
    <van-icon name="down" color='#030' size="18" />
  </template> -->
  </van-nav-bar>
    <h2>货空间用户协议</h2>
    <!-- <a href="https://www.baidu.com">123</a> -->
    <p>
      您好！为了更好地向您提供服务，请您仔细阅读本协议，充分理解并认同本协议后再注册，本协议是您与都有（上海）供应链管理有限公司就您登陆货空间app进行注册或使用所涉及权利义务等规范协议，您阅读后点击同意按钮注册并使用，均表示您同意本协议的全部约定，同时，您应该持续关注本注册协议的变更，亦可发表您的宝贵意见，如果您是未成年人，您还应要求您的监护人仔细阅读本协议，并取得他（她）们的同意。 
    </p>
    <p>一、注册更新</p>
    <p>
       1、货空间app（指货空间手机应用软件，以下简称“本网站”、“货空间”）各项服务的所有权和运作权归属于都有（上海）供应链管理有限公司所有。您确认注册条款，提供合法有效身份证明、手机号码，并完成相应注册程序，本协议在您与都有（上海）供应链管理有限公司间成立，并发生法律效力，同时您成为本网站正式用户，本网站有权根据经营需要向您收回账号，同时，本网站严格禁止任何赠与、转让、租用、借用或有价出售账号等行为。 
    </p>
    <p>
      2、依据外界条件变化及本网站运营需要，本网站有权对本协议条款及相关规则不时地进行修改，修改后的内容一旦以任何形式公布在本网站上即生效，并取代此前相关内容，您应不时关注本网站公告、提示信息及协议、规则等相关内容的变动。您知悉并确认，如您不同意更新后的内容，应立即停止使用本网站；如您继续使用本网站，即视为知悉变动内容并同意接受。
    </p>
    <p>二、注册须知</p>
    <p>1、本网站运用自身开发的操作系统为用户提供购买商品等服务。</p>
    <p>2、基于本网站所提供的服务，您确认并同意：</p>
    <p>
      （1）您需提供有效身份证、营业执照等证明材料，提供的注册资料真实、准确、完整、合法，注册资料如有变动的，应及时更新；
    </p>
    <p>
      （2）如果您提供的注册资料不合法、不真实、不准确、不详尽的，您需承担因此引起的相应法律责任及后果，并且本网站保留终止您使用本网站各项服务的权利。
    </p>
    <p>
      3、货空间作为交易平台，不参与任何品牌供应商与用户间达成的交易，货空间不对品牌供应商或其交易作任何承诺、陈述，不对品牌供应商发布信息、交易行为的真实性负责,您因此与品牌供应商发生纠纷，应通过协商方式解决，货空间有权介入、并协助调查、处置，但最终所有责任与货空间无关。
    </p>
    <p>
      4、请您注意：货空间展示的商品均由品牌供应商提供，因销售产生的所有责任、义务均由供应商承担。
    </p>
    <p>三、订单须知</p>
    <p>
      1、使用本网站下订单，您应具备购买相关商品的权利能力和行为能力，在下订单的同时，即视为您满足上述条件，并对您在订单中提供的所有信息的真实性负责。
    </p>
    <p>
      2、在您下订单时，请您仔细确认所购商品的名称、价格、数量、型号、规格、尺寸、联系地址、电话、收货人等信息。收货人与您本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。
    </p>
    <p>
      3、您理解并同意：本网站上销售商展示的商品和价格等信息仅仅是要约邀请，您下单时须填写您希望购买的商品数量、价款及支付方式、收货人、联系方式、收货地址（合同履行地点）、合同履行方式等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，是您向货空间发出的要约；
    </p>
    <p>
      4、尽管货空间做出最大的努力，但由于市场变化及各种以合理商业努力难以控制因素的影响，本网站无法避免您提交的订单信息中的商品出现缺货、价格标示错误等情况；如您下单所购买的商品出现以上情况，您有权取消订单，货空间亦有权自行取消订单，若您已经付款，则为您办理退款。
    </p>
    <p>
      5、您提交订单后，请立即向都有（上海）供应链有限公司支付货款，款项到帐后，货空间会及时安排供应商发货。
    </p>
    <p>四、配送交付</p>
    <p>
      1、您在本网站购买的商品将按照本网站上您所指定的送货地址进行配送。您应当清楚准确地填写您的送货地址、联系人及联系方式等配送信息。您知悉并确认：您所购买的商品应仅由您填写的联系人接受身份查验后接收商品，因您变更联系人或相关配送信息而造成的损失由您自行承担。
    </p>
    <p>
      2、因如下情况造成订单延迟或无法配送等，本网站将无法承担迟延配送或无法配送的责任：
    </p>
    <p>（1）客户提供错误手机号码和不详细的地址；</p>
    <p>
      （2）货物送达无人签收或拒收，由此造成的重复配送所产生的费用及相关的后果。
    </p>
    <p>（3）不可抗力、意外事件。</p>
    <p>
      3、您在本网站购买的商品约定由社会车辆或物流公司为您完成订单交付的，物流运输过程及物流票据均由社会车辆或物流公司负责；系统或单据记录的签收时间为交付时间；货空间不承担因用户使用、保管、保养、运输中出现的产品质量和数量下降/丢失/损坏而提出异议、退货、退款的请求。
    </p>
    <p>
      4、您收到商品后需进行清点、查验，无异议后签字或盖章确认。如有异议，您须在7日内向货空间提出，否则视为您放弃申诉异议的权利。
    </p>
    <p>五、注册信息</p>
    <p>
      1、您知悉并同意，为方便您使用本网站相关服务，您授权同意本网站将存储您在使用时的必要信息，包括但不限于您的真实姓名、性别、配送地址、联系方式、定位信息等。除法律法规规定的情形外，未经您的许可，货空间不会故意向第三方公开、透露您的个人信息。
    </p>
    <p>
      2、您知悉并确认，您在注册帐号或使用本网站的过程中，需要提供真实的身份信息，货空间将根据国家法律法规相关要求，进行真实身份信息认证。若您提供的信息不真实、不完整，则无法使用本网站或在使用过程中受到限制，同时，由此产生的不利后果，由您自行承担。
    </p>
    <p>3、您充分理解并同意：</p>
    <p>
      （1）接收通过邮件、短信、电话等形式，向在本网站注册、购物的用户、收货人发送的订单信息、促销活动等内容；
    </p>
    <p>
      （2）为配合行政监管机关、司法机关执行工作，在法律规定范围内货空间有权向上述行政、司法机关提供您在使用本网站时所储存的相关信息，包括但不限于您的注册信息等，或使用相关信息进行证据保全，包括但不限于公证、见证等；
    </p>
    <p>
      （3）货空间依法保障您在安装或使用过程中的知情权和选择权，在您使用本网站服务过程中，涉及您设备自带功能的服务会提前征得您同意，您一经确认，货空间有权开启包括但不限于收集地理位置等提供服务必要的辅助功能。
    </p>
    <p>六、行为规范</p>
    <p>本协议依据国家相关法律法规规章制定，您同意严格遵守以下条款：</p>
    <p>
      （1）不得干扰本网站的正常运转，不得侵入本网站及国家计算机信息系统；对本网站进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本网站的源代码。
    </p>
    <p>
      对本网站或者本网站运行过程中释放到任何终端内存中的数据、网站运行过程中客户端与服务器端的交互数据，以及本网站运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经货空间授权的第三方工具/服务接入本网站和相关系统。
    </p>
    <p>
      通过修改或伪造网站运行中的指令、数据，增加、删减、变动网站的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的。
    </p>
    <p>
      （2）未经本网站同意，不得私自转让平台账户，不得利用在本网站注册的账户进行任何牟利性、营利性活动；
    </p>
    <p>
      （3）不得发布、发表任何危害公共安全、国家安全的言论、观点，不得作出任何侵犯他人隐私、个人信息、著作权、商标权等知识产权或合法权利的行为；
    </p>
    <p>（4）其他法律法规禁止的行为。</p>
    <p>七、软件更新</p>
    <p>
      1、您可以直接从货空间网站上获取移动客户端软件，也可以从得到货空间授权的第三方获取，如果您从未经货空间授权的第三方获取软件或与货空间移动客户端软件名称相同的安装程序，货空间无法保证该软件的合法性、真实性，并对因此给您造成的任何损失不予赔偿；
    </p>
    <p>
      2、为了改善用户体验、完善服务内容，货空间将不断努力开发新的服务，并为您不时提供软件更新，新版本发布后，旧版本的软件可能无法使用，货空间不保证旧版本软件继续可用及相应的客户服务，并不承担任何责任，请您随时核对并下载最新版本软件。
    </p>
    <p>八、违约责任</p>
    <p>
      1、如果货空间发现或收到他人举报投诉您违反本协议约定或存在任何恶意行为的，货空间有权不经通知您，并有权随时对相关内容进行删除、屏蔽，并视您的行为情节、后果对您的违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁、账号注销等处罚。
    </p>
    <p>
      2、货空间有权依据合理判断对违反有关法律法规或本协议规定的行为采取适当的法律行动，并依据法律法规作出保存有关信息向有关部门报告等举措，您应独自承担由此而产生的一切法律责任。
    </p>
    <p>
      3、您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；货空间因此遭受损失的，您也应当一并赔偿。
    </p>
    <p>
      4、除非另有明确的书面说明,货空间不对本网站的运营及其包含在本网站上的信息、内容、材料、产品或服务作任何形式的、明示或默示的声明或担保。
    </p>
    <p>九、其他约定</p>
    <p>
      1、本协议的订立、执行和解释及争议的解决均应适用中国法律。如双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，双方约定向上海市闵行区人民法院提起诉讼。
    </p>
    <p>
      2、如本协议中任何一条被视为废止、无效或因任何理由不可执行，该条款应视为可分的，且并不影响任何其余条款的有效性和可执行性。
    </p>
    <p>
      3、本协议未明示授权的其他权利仍由货空间保留，您在行使这些权利时须另外取得货空间的书面许可。货空间如果未行使前述任何权利，并不构成对该权利的放弃。
    </p>
    <p>
      4、您注册所填写的地址视为默认合法有效的通讯地址，如您的经营地址发生变更，须及时更改，因更换不及时造成的所有责任均由您承担。
    </p>
   
  </div>
</template>
<script>
import Vue from 'vue'
import { NavBar } from 'vant'
import jsBridge from '../../../config/jsbridge-mini.js'

Vue.use(NavBar)
export default {
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    onClickRight(){
jsBridge.openInBrowser('https://m.baidu.com');
    }
  },
}
</script>
<style lang="less" scoped>
.img{
  width: 0.6rem;
  margin-right: 0.2rem;
}
h2 {
  padding-top: 1.5rem;
  font-size: 0.5rem;
  text-align: center;
}
h3 {
  text-align: center;
  font-size: 0.5rem;
  padding-top: 0.5rem;
}
p {
  text-indent: 1rem;
  line-height: 0.773333rem;
  font-family: '仿宋';
  color: #000;
  font-size: 0.426667rem;
  padding: 0 0.2rem;
}
</style>
